import { Component, Input } from '@angular/core'
import { Editor, EditorManager, RawEditorOptions } from 'tinymce'
import { ApiService } from '../api.service'

@Component({
	selector: 'tinymce-editor',
	templateUrl: './tinymce-editor.component.html',
	styleUrls: ['./tinymce-editor.component.scss']
})

export class TinymceEditorComponent {

	@Input() id = ''
	@Input() content = ''
	@Input() focus = true
	@Input() course = 0
	@Input() unit = 0
	@Input() lesson = 0
	@Input() heading = 0
	loading = true
	
	manager!: EditorManager
	tinymceConfig: RawEditorOptions = {
		language: 'es',
		entity_encoding: 'raw',
		remove_linebreaks : true,
		height: 500,
		browser_spellcheck: true,
		paste_data_images: true,
		plugins: 'advlist anchor autolink autoresize charmap code fullscreen help image insertdatetime link lists media preview searchreplace table template visualblocks wordcount template',
		menubar: false,
		toolbar: [
			'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | superscript subscript | link table | preview fullscreen',
			'blocks fontsize fontfamily | forecolor backcolor removeformat | template | code'
		],
		templates: 'tinymce/templates/templates.json',
		content_style: 'p.ai-generated { font-family: Consolas, monaco, monospace; background-color: #023020; color: white; padding: 3px; }',
		images_upload_handler: (blobInfo) => this.imageUpload(blobInfo),
		setup: (editor: Editor) => {
			editor.on('keyup change', (event: any) => {
				// console.log(editor.getContent())
			})
			editor.setContent(this.content)
			this.manager = editor.editorManager
		},
	}

	constructor(private dataService: ApiService) {}

	init() {
		this.loading = false
		if (this.focus) this.getEditor(this.id).focus()
	}

	getEditor(id: string) {
		return this.manager.get(id)!
	}

	getEditorContent(id: string) {
		return this.getEditor(id).getContent()
	}

	setEditorContent(id: string, content: string) {
		return this.getEditor(id).setContent(content)
	}

	insertAtEnd(id: string, content: string) {
		let prevContent = this.getEditorContent(id)
		let insertPos = prevContent.indexOf('[') - 3
		content = prevContent.slice(0, insertPos) + content + prevContent.slice(insertPos)
		this.setEditorContent(id, content)

		let selectedNode = this.getEditor(id).dom.select('p.ai-generated')[0].nextSibling as Node
		this.getEditor(id).selection.setCursorLocation(selectedNode, 0)
		this.getEditor(id).focus()
	}

	refresh(id: string) {
		return this.setEditorContent(id, this.getEditorContent(id))
	}

	isEditorDirty(id: string) {
		return this.getEditor(id).isDirty()
	}

	// TODO: TEST
	imageUpload(blobInfo: any) {
		// const file = blobInfo.blob();
		// const filePath = `${Date.now()}-${blobInfo.filename()}`;
		// const ref = this.storage.ref(filePath);
		// const task = this.storage.upload(filePath, file);
		// const promise = new Promise<string>((resolve, reject) => {
		// 	task
		// 		.snapshotChanges()
		// 		.pipe(
		// 			finalize(() =>
		// 				ref
		// 					.getDownloadURL()
		// 					.pipe(last())
		// 					.subscribe((url) => {
		// 						resolve(url);
		// 					})
		// 			)
		// 		)
		// 		.subscribe((_) => {
		// 			// do nothing
		// 		});
		// });
		// return promise;

		// progress(0)
		
		const promise = new Promise<string>((resolve, reject) => {
			let content = this.getEditorContent(this.id)
			// console.log(content)
			let contentImgIndex = content.indexOf('<img src="data:')
			if (contentImgIndex == -1) {
				reject('Archivo subido no es una imagen')
			}
			let contentImg = content.substring(contentImgIndex, content.indexOf('">', contentImgIndex) + 2)
			// let contentImgType = content.substring(contentImgIndex, content.indexOf(';', contentImgIndex)).slice(15)
			// let contentImgExt = contentImgType.replace('image/', '')
			let file = blobInfo.blob() as File
			// console.log(file)
			
			this.dataService.uploadMultimedia(this.course, this.lesson, 'image', file)
			.subscribe(
				(insertCode: any) => {
					// console.log(insertCode)
					this.setEditorContent(this.id, content.replace(contentImg, insertCode))
					// this.refresh(this.id)
					// progress(100)
					resolve(insertCode)
				},
				(error: any) => {
					console.log(error)
					// failure(error)
					reject(error)
				}
			)
		})

		return promise
	}

}